<template>
  <div class="medical-item-component" :class="{ 'is-mobile': isMobile }">
    <!-- 头部信息 -->
    <div class="item-header" :class="isOpen ? 'open' : ''" @click="toggleOpen">
      <div class="header-top">
        <div class="header-info">
          <span class="label">就诊时间:</span>
          <span class="value">{{ medicalItem.appointTime }}</span>
        </div>
      </div>
      <div class="header-bottom">
        <div class="header-row">
          <span class="label">医生:</span>
          <span class="value">{{ medicalItem.doctorName }}</span>
        </div>
        <div class="header-row">
          <span class="label">护士:</span>
          <span class="value">{{ medicalItem.nurseName }}</span>
        </div>
      </div>
      <div class="toggle-text" v-if="!isOpen">展开</div>
    </div>

    <!-- 展开内容 -->
    <div class="item-main" v-if="isOpen">
      <!-- 主诉 -->
      <div class="content-section" v-if="medicalItem.chiefComplaint">
        <div class="section-title">主诉</div>
        <div class="section-text">{{ medicalItem.chiefComplaint }}</div>
      </div>

      <!-- 现病史 -->
      <div class="content-section" v-if="medicalItem.presentHistory">
        <div class="section-title">现病史</div>
        <div class="section-text">{{ medicalItem.presentHistory }}</div>
      </div>

      <!-- 既往史 -->
      <div class="content-section" v-if="medicalItem.pastHistory">
        <div class="section-title">既往史</div>
        <div class="section-text">{{ medicalItem.pastHistory }}</div>
      </div>

      <!-- 过敏史 -->
      <div class="content-section" v-if="medicalItem.allergicHistory">
        <div class="section-title">过敏史</div>
        <div class="section-text">{{ medicalItem.allergicHistory }}</div>
      </div>

      <!-- 查体 -->
      <div class="content-section" v-if="medicalItem.physicalExamination">
        <div class="section-title">查体</div>
        <div class="section-text">{{ medicalItem.physicalExamination }}</div>
      </div>

      <!-- 口腔检查 -->
      <div class="content-section" v-if="medicalItem.oralCheckTooths">
        <div class="section-title">口腔检查</div>
        <div class="item-list">
          <div
            class="list-item"
            v-for="(exam, eIndex) in medicalItem.oralCheckTooths"
            :key="eIndex"
          >
            <div class="tooth-position" v-if="exam.fdiToothCodes">
              <H5ToothMap :toothPosition="exam.fdiToothCodes" />
            </div>
            <div class="item-content">{{ exam.content }}</div>
          </div>
        </div>
      </div>

      <!-- 辅助检查 -->
      <div class="content-section" v-if="medicalItem.radiologyCheckTooths">
        <div class="section-title">辅助检查</div>
        <div class="item-list">
          <div
            class="list-item"
            v-for="(exam, eIndex) in medicalItem.radiologyCheckTooths"
            :key="eIndex"
          >
            <div class="tooth-position" v-if="exam.fdiToothCodes">
              <H5ToothMap :toothPosition="exam.fdiToothCodes" />
            </div>
            <div class="item-content">{{ exam.content }}</div>
          </div>
        </div>
      </div>

      <!-- 相关影像 -->
      <div
        class="content-section"
        v-if="medicalItem.imageList && medicalItem.imageList.length > 0"
      >
        <div class="section-title">相关影像</div>
        <div class="image-list row flex-wrap">
          <div
            v-for="(imgItem, imgIndex) in medicalItem.imageList"
            :key="imgIndex"
            class="image-list-item"
          >
            <ViewPhotoItem
              :imgSrc="imgItem.imageUrl"
              :imgList="medicalItem.imageList.map(({ imageUrl }) => imageUrl)"
            />
          </div>
        </div>
      </div>

      <!-- 诊断 -->
      <div class="content-section" v-if="medicalItem.diagnosisTooths">
        <div class="section-title">诊断</div>
        <div class="item-list">
          <div
            class="list-item"
            v-for="(diag, dIndex) in medicalItem.diagnosisTooths"
            :key="dIndex"
          >
            <div class="tooth-position" v-if="diag.fdiToothCodes">
              <H5ToothMap :toothPosition="diag.fdiToothCodes" />
            </div>
            <div class="item-content">{{ diag.content }}</div>
          </div>
        </div>
      </div>

      <!-- 治疗计划 -->
      <div class="content-section" v-if="medicalItem.treatmentPlanTooths">
        <div class="section-title">治疗计划</div>
        <div class="item-list">
          <div
            class="list-item"
            v-for="(plan, pIndex) in medicalItem.treatmentPlanTooths"
            :key="pIndex"
          >
            <div class="tooth-position" v-if="plan.fdiToothCodes">
              <H5ToothMap :toothPosition="plan.fdiToothCodes" />
            </div>
            <div class="item-content">{{ plan.content }}</div>
          </div>
        </div>
      </div>

      <!-- 处置 -->
      <div class="content-section" v-if="medicalItem.cureTooths">
        <div class="section-title">处置</div>
        <div class="item-list">
          <div
            class="list-item"
            v-for="(treat, tIndex) in medicalItem.cureTooths"
            :key="tIndex"
          >
            <div class="tooth-position" v-if="treat.fdiToothCodes">
              <H5ToothMap :toothPosition="treat.fdiToothCodes" />
            </div>
            <div class="item-content">{{ treat.content }}</div>
          </div>
        </div>
      </div>

      <!-- 医嘱 -->
      <div class="content-section" v-if="medicalItem.advise">
        <div class="section-title">医嘱</div>
        <div class="section-text">{{ medicalItem.advise }}</div>
      </div>

      <!-- 标签 -->
      <div class="content-section" v-if="medicalItem.emrLabel">
        <div class="section-title">标签</div>
        <div class="section-text">{{ medicalItem.emrLabel }}</div>
      </div>

      <!-- 备注 -->
      <div class="content-section" v-if="medicalItem.remark">
        <div class="section-title">备注</div>
        <div class="section-text">{{ medicalItem.remark }}</div>
      </div>

      <div class="toggle-text" v-if="isOpen" @click="toggleOpen">收起</div>
    </div>
  </div>
</template>

<script>
import ViewPhotoItem from "@/components/publick/viewPhotoItem";
import H5ToothMap from "@/components/publick/h5toothmap.vue";

export default {
  name: "MedicalItem",
  components: {
    H5ToothMap,
    ViewPhotoItem,
  },
  props: {
    // 是否为移动端模式,默认true使用rem,false使用px
    isMobile: {
      type: Boolean,
      default: true,
    },
    // 单个病历信息
    medicalItem: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    // 切换展开/收起
    toggleOpen() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style lang="scss" scoped>
.medical-item-component {
  text-align: left;
  background-color: #fff;
  border: 1px solid #e6e6e6;
  overflow: hidden;

  // 移动端样式(使用rem)
  &.is-mobile {
    font-size: 0.292rem;
    border-radius: 0.083rem;

    .item-header {
      padding: 0.25rem;

      .header-top {
        margin-bottom: 0.167rem;

        .header-info {
          .label {
            margin-right: 0.083rem;
          }
        }
      }

      .header-bottom {
        .header-row {
          .label {
            margin-right: 0.083rem;
          }
        }
      }
    }

    .item-main {
      padding: 0.25rem;

      .content-section {
        margin-bottom: 0.25rem;

        .section-title {
          font-size: 0.292rem;
          margin-bottom: 0.125rem;
        }

        .section-text {
          line-height: 1.6;
          font-size: 0.271rem;
        }

        .image-list {
          gap: 0.25rem;
          .image-list-item {
            width: 1.667rem;
            height: 1.667rem;
          }
        }

        .list-item {
          display: flex;
          align-items: center;
          margin-bottom: 0.25rem;

          .tooth-position {
            margin-bottom: 0.125rem;
            flex: 2 0;
            max-width: 3.125rem;

            & + .item-content {
              margin-left: 0.167rem;
            }
          }

          .item-content {
            flex: 3;
            font-size: 0.292rem;
          }
        }
      }
    }

    .toggle-text {
      font-size: 0.271rem;
      padding-top: 0.167rem;
      margin-bottom: -0.167rem;
    }
  }

  // PC端样式(使用px)
  &:not(.is-mobile) {
    font-size: 14px;
    border-radius: 4px;

    .item-header {
      padding: 12px;

      .header-top {
        margin-bottom: 8px;

        .header-info {
          .label {
            margin-right: 4px;
          }
        }
      }

      .header-bottom {
        .header-row {
          .label {
            margin-right: 4px;
          }
        }
      }
    }

    .item-main {
      padding: 12px;

      .content-section {
        margin-bottom: 12px;

        .section-title {
          font-size: 14px;
          margin-bottom: 6px;
        }

        .section-text {
          line-height: 1.6;
          font-size: 13px;
        }

        .image-list {
          gap: 12px;
          .image-list-item {
            width: 80px;
            height: 80px;
          }
        }

        .list-item {
          display: flex;
          align-items: center;
          margin-bottom: 12px;

          .tooth-position {
            margin-bottom: 6px;
            max-width: 175px;
            flex: 2 0;

            & + .item-content {
              margin-left: 8px;
            }
          }

          .item-content {
            flex: 3;
            font-size: 14px;
          }
        }
      }
    }

    .toggle-text {
      font-size: 13px;
      padding-top: 8px;
      margin-bottom: -8px;
      cursor: pointer;
    }
  }

  .item-header {
    &.open {
      border-bottom: 1px solid #e6e6e6;
    }
    cursor: pointer;

    .header-top {
      display: flex;
      align-items: center;

      .header-info {
        flex: 1;
        display: flex;
        align-items: center;

        .label {
          color: #666;
        }

        .value {
          color: #333;
          font-weight: 500;
        }
      }
    }

    .header-bottom {
      display: flex;
      align-items: center;

      .header-row {
        display: flex;
        align-items: center;
        flex: 1;

        .label {
          color: #666;
        }

        .value {
          color: #333;
        }
      }
    }
  }

  .item-main {
    .content-section {
      .section-title {
        color: #666;
      }

      .section-text {
        color: #333;
      }

      .item-list {
        .list-item {
          .item-content {
            color: #333;
            word-break: break-all;
          }
        }
      }
    }
  }

  .toggle-text {
    color: #28b8c3;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}
</style>
